var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Edit"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    rx: 2,
    transform: "rotate(180 24 24)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5.6 15.0391L4 19.9991L8.96 18.3991L5.6 15.0391Z",
    fill: "#46484C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M6.72369 13.8906L14.53 6.08431L17.9241 9.47837L10.1178 17.2847L6.72369 13.8906Z",
    fill: "#46484C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M19.76 6.48L17.52 4.24C17.2 3.92 16.72 3.92 16.4 4.24L15.68 4.96L19.04 8.32L19.76 7.6C20.08 7.28 20.08 6.8 19.76 6.48Z",
    fill: "#46484C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/Icon-Edit.7e1cfded38447d716e245773215f4678.svg";
export { ForwardRef as ReactComponent };